import React from 'react';
import { browserHistory } from 'react-router';
import { routes, menus, accountConstants } from '../constants';
import { RouteActions } from '../actions';
import { Card, TabSet, Tab, Menu, LoginForm, RegistrationForm, AppCTA } from '../components';
import AuthComponent from './auth-component';
import { AuthDelegate } from '../utils';

const { statuses } = accountConstants;

export default class LoginWidget extends AuthComponent {

    dispatchPage(){
        this.props.dispatch(RouteActions.setAppState(routes.LOGIN));
    }

    componentDidMount() {
        this.dispatchPage(this.props.dispatch);
    }

    userIsAuthorized(user){
        return AuthDelegate.userIsLoggedIn(false)(user);
    }

    componentWillRejectUser(user) {
        switch (user.approvalStatus) {
            case statuses.APPROVED:
                browserHistory.push(routes.HOME);
                break;
            case statuses.DENIED:
                browserHistory.push(routes.DENIED);
                break;
            case statuses.SUBMITTED:
                browserHistory.push(routes.SUBMITTED);
                break;
            case statuses.UNSUBMITTED:
                browserHistory.push(routes.VERIFY);
                break;
            default:
                browserHistory.push(routes.HOME);
                break;
        }
    }

    authRender() {
        return (
            <div className="container component-login-widget">
                <div className="row center-cols">
                    {/*<div className="col-md-6 col-lg-5 page-header">
                        <h1 className="page-title">Welcome</h1>
                        <p>
                            Welcome to the Oil Service Labratories Web Portal. <a href={routes.APP_STORE} target="_blank">Install our app</a> to submit samples, or log in below to view your sample results and download PDF reports.
                        </p>
                    </div>*/}
                    <div className="col-md-6 col-lg-5">
                        <Card>
                            <Menu className="login-menu no-collapse" items={menus.LOGIN} appState={this.props.currentRoute} />
                            <TabSet className="login-tabs" switch={this.props.currentRoute}>
                                <Tab value={routes.LOGIN}>
                                    <LoginForm />
                                </Tab>
                                <Tab value={routes.REGISTER}>
                                    <RegistrationForm />
                                </Tab>
                            </TabSet>
                        </Card>
                        <AppCTA />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web-app/components/login-widget.jsx